import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut, UserCog } from "lucide-react";
import { useTeamAuth } from "@/lib/teamAuth";

export default function TeamShell({ children }) {
    const { member, logout } = useTeamAuth();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const tabs = [
        { to: "/team", label: "Clients", match: pathname === "/team" || pathname === "/team/" },
    ];

    return (
        <main data-testid="team-shell" className="min-h-screen bg-ink text-bone">
            <header className="sticky top-0 z-30 bg-ink/80 backdrop-blur-xl border-b border-white/10">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
                    <Link to="/team" className="flex items-center gap-3" data-testid="team-brand">
                        <img src="/logo.png" alt="Aximo Studios" className="h-9 w-auto" />
                        <span className="font-display text-base tracking-tight text-bone-300 hidden sm:inline">
                            /Manager
                        </span>
                    </Link>

                    <nav className="hidden md:flex items-center gap-2">
                        {tabs.map((t) => (
                            <Link
                                key={t.to}
                                to={t.to}
                                data-testid={`team-tab-${t.label.toLowerCase()}`}
                                className={`px-4 h-10 inline-flex items-center text-xs uppercase tracking-[0.2em] border transition-colors ${
                                    t.match
                                        ? "border-ember text-ember"
                                        : "border-white/15 text-bone-300 hover:border-white/30 hover:text-bone"
                                }`}
                            >
                                {t.label}
                            </Link>
                        ))}
                    </nav>

                    <div className="flex items-center gap-3">
                        {member && (
                            <span className="hidden sm:inline-flex items-center gap-2 text-xs text-bone-500">
                                <UserCog className="w-3.5 h-3.5 text-ember" />
                                {member.name} · {member.role}
                            </span>
                        )}
                        <button
                            onClick={() => {
                                logout();
                                navigate("/team/login");
                            }}
                            data-testid="team-logout"
                            className="inline-flex items-center gap-2 h-10 px-4 border border-white/15 hover:border-white/30 transition-colors text-xs uppercase tracking-[0.18em]"
                        >
                            <LogOut className="w-3.5 h-3.5" />
                            Sign out
                        </button>
                    </div>
                </div>
            </header>
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10">{children}</div>
        </main>
    );
}
